import { Text } from '@sbab-ui/components'
import { ReactNode } from 'react'

interface CommonProps {
  className?: string
  children: ReactNode
  ['data-cy']?: string
}

export function MainHeading({ children }: Readonly<CommonProps>) {
  return (
    <div className="my-6 sm:my-12">
      <Text as="h1" className="!text-3xl !text-black sm:!text-4xl">
        {children}
      </Text>
    </div>
  )
}

interface TypographyPProps extends CommonProps {
  type?: 'xl' | 'display' | 'lead' | 'base' | 'banner'
}

export function TypographyP({
  className = '',
  children,
  type,
  'data-cy': dataCy,
}: Readonly<TypographyPProps>) {
  switch (type) {
    case 'display':
      return (
        <Text
          className={`!mt-0 !text-4xl font-medium min-[375px]:!text-5xl ${className}`}
          data-cy={dataCy}
        >
          {children}
        </Text>
      )
    case 'xl':
      return (
        <Text className={`!mb-4 !mt-0 !text-xl ${className}`} data-cy={dataCy}>
          {children}
        </Text>
      )
    case 'lead':
      return (
        <Text className={`!mt-0 ${className}`} size="lead" mb="2x">
          {children}
        </Text>
      )
    case 'base':
      return (
        <Text className={`!mt-0 ${className}`} size="base">
          {children}
        </Text>
      )
    case 'banner':
      return (
        <Text size="base" mb="2x">
          {children}
        </Text>
      )
    default:
      return (
        <Text className={`!mt-0 !text-xs min-[375px]:!text-base ${className}`}>
          {children}
        </Text>
      )
  }
}

interface TypographyH2Props extends CommonProps {
  type?: 'display' | 'banner'
}

export function TypographyH2({
  className = '',
  children,
  type,
  'data-cy': dataCy,
}: Readonly<TypographyH2Props>) {
  if (type === 'display')
    return (
      <Text as="h2" className={`!mb-2 ${className}`} data-cy={dataCy}>
        {children}
      </Text>
    )
  if (type === 'banner')
    return (
      <Text as="h2" size="h3" mb="2x" mt="2x">
        {children}
      </Text>
    )

  return (
    <div className="!pb-8 !pt-2">
      <Text as="h2" className={`!text-[32px] ${className}`}>
        {children}
      </Text>
    </div>
  )
}

export function TypographyH3({ 
  className = '', 
  children,
  'data-cy': dataCy,
 }: Readonly<CommonProps>) {
  return (
    <Text as="h3" size="h3" className={`!mb-1 ${className}`} data-cy={dataCy}>
      {children}
    </Text>
  )
}
